import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { getAuthSession } from '@/hooks/useAuth';

interface PrivateRouteProps {
  children: ReactNode;
}

export default function PrivateRoute({ children }: PrivateRouteProps) {
  const location = useLocation();
  const session = getAuthSession();

  if (!session.isAuthenticated) {
    return (
      <Navigate
        to="/premiado/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return <>{children}</>;
}
